import { Box, Fab, Tooltip } from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import { useIntl } from "react-intl";
import { ResourceV2 } from "services/KnowfullyAdminClient";

const styles = {
  topButtons: {
    my: 3,
    gap: 3,
    display: "flex",
    justifyContent: "center",
  },
};

type ResourceDetailsTopButtonsProps = {
  resource: ResourceV2;
  onAddClick: () => void;
  onSkusClick: () => void;
  onLinkUserClick: () => void;
  onUnlinkUserClick: () => void;
  onDeleteClick: () => void;
};

export default function ResourceDetailsTopButtons({
  resource,
  onAddClick,
  onSkusClick,
  onLinkUserClick,
  onUnlinkUserClick,
  onDeleteClick,
}: ResourceDetailsTopButtonsProps) {
  const { formatMessage: t } = useIntl();
  const canLinkUser = !resource.organizationUserId;
  const canDelete = !resource.hasSkus && !resource.organizationUserId;

  const deleteButtonTooltipText = resource.hasSkus
    ? t({ id: "facultyCantBeDeletedBecauseAssociatedWithSkus" })
    : resource.organizationUserId
    ? t({ id: "facultyCantBeDeletedBecauseAssociatedToUser" })
    : t({ id: "deleteFaculty" });

  return (
    <Box sx={styles.topButtons}>
      <Tooltip title={t({ id: "editFaculty" })}>
        <Fab aria-label="add" color="primary" onClick={onAddClick}>
          <EditIcon />
        </Fab>
      </Tooltip>

      <Tooltip title={t({ id: "associatedSkus" })}>
        <Fab color="primary" onClick={onSkusClick}>
          <LocalLibraryIcon />
        </Fab>
      </Tooltip>

      {canLinkUser ? (
        <Tooltip title={t({ id: "linkUserToFaculty" })}>
          <Fab color="primary" onClick={onLinkUserClick}>
            <PersonAddIcon />
          </Fab>
        </Tooltip>
      ) : (
        <Tooltip title={t({ id: "unlinkFacultyAndUser" })}>
          <Fab color="primary" onClick={onUnlinkUserClick}>
            <PersonRemoveIcon />
          </Fab>
        </Tooltip>
      )}

      <Tooltip title={deleteButtonTooltipText}>
        <Box>
          <Fab color="secondary" onClick={onDeleteClick} disabled={!canDelete}>
            <DeleteIcon />
          </Fab>
        </Box>
      </Tooltip>
    </Box>
  );
}
